export default __webpack_public_path__ + "static/media/load-icon.1bc2f71b.gif";